// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchBeginLoadBrands,
    DispatchCompleteLoadBrandGallery,
} from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrands";

export const DispatchBeginLoadFeatureBrands: typeof DispatchBeginLoadBrands = props => {
    if (
        (props.parameter as any).headerFeaturedBrands &&
        (props.getState() as CustomAppState).xHeader.isFeaturedBrandsLoading
    ) {
        return false;
    }

    if ((props.parameter as any).headerFeaturedBrands) {
        props.dispatch({
            type: "xHeader/featuredBrands",
            isFeaturedBrandsLoading: true,
        } as any);
    }
};

export const xDispatchCompleteLoadBrandGallery: any = (props: any) => {
    if (props.parameter.headerFeaturedBrands) {
        const brands = props.apiResult.brands;
        props.dispatch({
            type: "xHeader/featuredBrands",
            featuredBrands: brands || [],
            isFeaturedBrandsLoading: false,
        });
    } else {
        props.dispatch({
            type: "Data/Brands/CompleteLoadBrands",
            parameter: props.parameter,
            collection: props.apiResult,
        });
    }
};

addToChainBefore(chain, DispatchBeginLoadBrands, DispatchBeginLoadFeatureBrands);
replaceInChain(chain, DispatchCompleteLoadBrandGallery, xDispatchCompleteLoadBrandGallery);
